export const C = {
  primary: '#6C3FC5',
  primaryLight: '#EDE8FA',
  primaryDark: '#4B2A9A',
  accent: '#F4A300',
  bg: '#F5F6FA',
  sidebar: '#1A1340',
  sidebarText: '#A89FC8',
  sidebarActive: '#6C3FC5',
  white: '#FFFFFF',
  border: '#E4E4EF',
  text: '#1C1C2E',
  textMuted: '#6B7280',
  success: '#10B981',
  warning: '#F59E0B',
  danger: '#EF4444',
  info: '#3B82F6',
};
